export default "__VITE_ASSET__bd155a9f__"